import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllMessages = () =>
  apiClient.get(REST_API_BASE_URL + '/messages');

//export const getAllAppsByAccount = (id) => apiClient.get(`${REST_API_BASE_URL}/message/${id}/apps`);

export const saveMessage = (message) =>
  apiClient.post(REST_API_BASE_URL + '/message', message);

export const getMessage = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/message/${id}`);

export const updateMessage = (id, message) =>
  apiClient.put(`${REST_API_BASE_URL}/message/${id}`, message);

export const deleteMessage = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/message/${id}`);

export const addUserToMessage = (messageid, userid) =>
  apiClient.post(`${REST_API_BASE_URL}/message/${messageid}/user/${userid}`);

export const getUsersByMessage = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/message/${id}/users`);

export default apiClient;
